import { render, staticRenderFns } from "./PayrollRunProcess.vue?vue&type=template&id=070b2fe6&scoped=true"
import script from "./PayrollRunProcess.vue?vue&type=script&lang=js"
export * from "./PayrollRunProcess.vue?vue&type=script&lang=js"
import style0 from "./PayrollRunProcess.vue?vue&type=style&index=0&id=070b2fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070b2fe6",
  null
  
)

export default component.exports